import React, { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Button, Snackbar } from '@material-ui/core'
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert'

const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

type AlertSnackbarProps = {
  alertMessage: string
  alertStyle?: any
  buttonContent?: string
  buttonIcon?: any
  copyContent: string
}

const AlertSnackbar = (props: AlertSnackbarProps) => {
  const { alertMessage, alertStyle, buttonContent, buttonIcon, copyContent } = props
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <CopyToClipboard text={copyContent}>
        <Button startIcon={buttonIcon} color="primary" onClick={handleClick}>
          {buttonContent}
        </Button>
      </CopyToClipboard>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" style={alertStyle}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default AlertSnackbar
